const footerExpandItems = document.querySelectorAll(".middle-item .item-title");
if (footerExpandItems.length > 0) {
    footerExpandItems.forEach((item) => {
        item.addEventListener("click", function (event) {
            item.parentElement.classList.toggle("show");
        });
    });
}
